import { createSelector } from '@ngrx/store';
import { getOneClickState } from '@ordersnproducts/modules/one-click-order/reducers';

export const getOneClickAdditionalServicesState = createSelector(
  getOneClickState,
  state => state.additionalServicesState,
);

export const getOneClickAdditionalServices = createSelector(
  getOneClickAdditionalServicesState,
  state => state.additionalServicesAvailable,
);

export const getOneClickAdditionalServicesSelected = createSelector(
  getOneClickAdditionalServicesState,
  state => state.selected,
);
